/**
 * Verqo brand mark — single source of truth for the "V" chip used in
 * portal sidebars, landing pages, the backend-down screen, etc.
 *
 * Mirrors `public/favicon.svg` pixel-for-pixel so the in-app chip is
 * identical to the browser-tab favicon. Use `size` (default 32) and
 * `className` to size it via Tailwind (`w-8 h-8 shrink-0`).
 *
 * The chip is a 14px-radius rounded square with a checkmark-V stroke
 * in `#dcff3a` (lime). Previously the portal sidebar rendered a
 * typographic "v" with no `shrink-0`, so it appeared as a tall pill
 * when the adjacent label expanded — that's fixed by using this
 * component everywhere instead of inline JSX.
 */
export function VerqoMark({ size, className = "" }) {
  // `size` controls both width/height. If a parent provides a Tailwind
  // size via className (`w-8 h-8` etc) leave `size` undefined and the
  // SVG inherits from the parent box.
  const sizeProps = size ? { width: size, height: size } : { width: "100%", height: "100%" };
  return (
    <span
      aria-label="verqo"
      className={`inline-flex shrink-0 ${className}`}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        viewBox="0 0 64 64"
        shapeRendering="geometricPrecision"
        {...sizeProps}
        role="img"
      >
        <rect x="0" y="0" width="64" height="64" rx="14" fill="#0c1612" />
        <path
          d="M14 22 L30 46 L54 8"
          fill="none"
          stroke="#dcff3a"
          strokeWidth="8.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
